import { defineStore } from 'pinia'

export const useUpgradeModalStore = defineStore('upgradeModal', {
  state: () => ({ visible: false, source: 'unknown' }),
  actions: {
    open ({ source }) {
      this.source = source || 'unknown'
      this.visible = true
    },
    close () {
      this.visible = false
    },
  },
})
